import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LocalstorageService } from './Common/localstorage.service';
import { ApiService } from './Common/api.service';
import { CompanyAddressModel, DeleteCompanyAddressModel } from '../models/companyAddress/company-address-model';
import { UrlHelperService } from './Common/urlhelper.service';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class CompanyAddressService {

  constructor(private _api: ApiService) { }

  CompanyAddressAdd(companyAddressModel: CompanyAddressModel) {
    return this._api.post(UrlHelperService.companyAddAddress, companyAddressModel)
  }

  GetCompanyAddressList(){
    return this._api.post(UrlHelperService.companyAddressList)
  }

  GetCompanyAddressById(id) {
    return this._api.get(UrlHelperService. getCompanyAddressrById + id)
  }

  CompanyUpdateAddress(companyAddressModel: CompanyAddressModel) {
    return this._api.post(UrlHelperService. upadteCompanyAddressDetail, companyAddressModel)
  }

  DeleteAddress(deleteAddressVm: DeleteCompanyAddressModel){
    return this._api.post(UrlHelperService.deleteCompanyAddress, deleteAddressVm)
  }
  getCustomerAddressId = new BehaviorSubject(<string>'');
  passId(id) {
    this.getCustomerAddressId.next(id);
  }
}
